// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"bb8fc9e7","25":"4e03365b","28":"c1e05e97","32":"d942c2f6","34":"1b0eda4b","35":"91a513b7"}[chunkId] + ".chunk.js";
};